import List from "@/components/list";
import router from "@/router";
import Bus from "./Bus.js";
import { getItem } from '@/utils/storage'

const Table = args => {
  const RCSelectionChange = args.listeners["selection-change"] || function () { };

  const shareManageHandle = args.listeners["share-manage"] || function () { };

  const deptLevelCode = getItem("deptLevelCode");

  function handleDelete(vo) {
    Bus.$emit("deleteBanner", vo.row);
  }
  function handleEdit(data) {
    router.push({
      path: "/banner/addBanner",
      query: {
        id: data.row.uuid
      }
    });
  }
  function toBannerDetail(item) {
    router.push({
      path: "/banner/detail",
      query: {
        id: item.uuid
      }
    });
  }
  function showDetail(vo) {
    Bus.$emit("showImg", vo.row);
  }
  function setDown(data, type) {
    Bus.$emit("setDown", { id: data, status: type });
  }
  function setUp(data, type) {
    Bus.$emit("setDown", { id: data, status: type });
  }

  const Deal = ({ props: { vo } }) => {
    let dealConf = [];
    if (vo.row.onlineStatus == 0 && vo.row.canShare == 1) {
      dealConf.push(["icon-edit", "编辑", () => handleEdit(vo), "banner:update"])
    } else {
      dealConf.push(["icon-edit-disable", "编辑", () => { }, "banner:update"]);
    }

    if (vo.row.onlineStatus == 1) {
      dealConf.push([
        "icon-delete-disable",
        "删除",
        () => {
          return;
        },
        "banner:delete"
      ])
      dealConf.push([
        "icon-down",
        "下线",
        () => setDown(vo.row.uuid, 0),
        "banner:online"
      ]);
    } else {
      dealConf.push(["icon-delete", "删除", () => handleDelete(vo), "banner:delete"])
      dealConf.push([
        "icon-up",
        "上线",
        () => setUp(vo.row.uuid, 1),
        "banner:online"
      ]);
    }

    if (vo.row.canShare == 1) {
      dealConf.push([
        "icon-share",
        "共享管理",
        () => shareManageHandle(vo.row),
        "pubBanner:share",
      ]);
    } else {
      dealConf.push([
        "icon-share-none",
        "共享管理",
        () => {},
        "pubBanner:share",
      ]);
    }
    // v-permission={item[2]}
    return (
      <div class="deal-group">
        {dealConf.map(item => (
          <el-tooltip content={item[1]} placement="top" v-permission={item[3]}>
            <i class={item[0]} onClick={item[2]}></i>
          </el-tooltip>
        ))}
      </div>
    );
  };
  const Img = ({ props: { vo } }) => {
    const url = vo.row.isApp === 1 ? vo.row.appCoverUrl : vo.row.isApplet === 1 ? vo.row.appletCoverUrl : vo.row.isPc === 1 ? vo.row.pcCoverUrl:vo.row.coverUrl
    return (
      <div >
        <el-image 
          style="width: 160px; height: 90px; cursor: pointer" 
          src={url} 
          fit={'contain'} 
          lazy
          preview-src-list={[url]}
        ></el-image>
      </div>
    );
  };

  const BannerName = ({ props: { vo } }) => {
    const bannerItem = vo.row;
    return (
      <div class="base-hover-char" onClick={() => toBannerDetail(bannerItem)}>
        {bannerItem.bannerTitle}
      </div>
    );
  }

  // function selectable(row, index) {
  //   return row.canShare == 1;
  // }


  const AccountTableConfig = [
    {
      type: "selection",
      label: "main", 
      // selectable: selectable
    },
    {
      label: "图片预览",
      width: "200",
      render: vo => <Img vo={vo} />
    },
    {
      label: "标题",
      minWidth: "250",
      render: vo => <BannerName vo={vo} />
    },
    {
      label: "展示终端",
      prop: "displayClientTypeName",
      minWidth: "100"
    },
    {
      label: "版权方",
      prop: "originDeptName",
      minWidth: "100"
    },
    {
      label: "已共享学院",
      prop: "sharedDeptNames",
      minWidth: "140"
    },
    {
      label: "创建者",
      prop: "createUserName",
      minWidth: "80"
    },
    {
      label: "创建时间",
      prop: "createDate",
      minWidth: "150"
    },
    {
      label: "状态",
      prop: "onlineStatusName",
      minWidth: "60"
    },
    {
      label: "操作",
      width: "160",
      fixed: "right",
      render: vo => <Deal vo={vo} />
    }
  ];



  return (
    <div>
      <List
        {...args}
        onSelectionChange={RCSelectionChange}
        talbeCols={AccountTableConfig}
      />
    </div>
  );
};

export default Table;
